import React from "react";
const TalentVideo = (props) => {
  return (
    <div>
    <div
      className={` p-1 sm:p-1.5 lg:p-1.5 flex justify-between flex-col cursor-pointer items-center xs:rounded-lg sm:rounded-xl lg:rounded-[20px] ${props.eventLayout}`}
      style={{ backgroundColor: props.eventtheme }}
      onClick={props.onClick}
    >
      <img
        src={props.eventthubmail}
        className={`w-full xs:rounded-lg sm:rounded-xl lg:rounded-[20px] h-[75%]`}
        alt="videothubmail"
      />
      
    </div>
    <div
        className={`flex justify-center items-center flex-col xs:pt-2 sm:pt-2 lg:pt-5 h-[25%]`}
      >
        <div className={`lg:max-w-full lg:mb-1`}>
          <p
            className={` text-white font-onestExtraBold text-center text-sm sm:text-[14px] lg:text-2xl xs:leading-3 sm:leading-4 lg:leading-7  ${props.textclassName}`}
          >
            {props.eventTitle}
          </p>
        </div>
        <div className="flex items-start xs:gap-x-1 lg:gap-x-2">
          <p className="text-white font-onestSemiBold xs:text-[12px] sm:text-xs lg:text-lg">
            {props.evetDate}
          </p>
          <p className="text-white font-onestSemiBold xs:text-[12px] sm:text-xs lg:text-lg">
            {props.eventDis}
          </p>
        </div>
      </div>
      </div>
  );
};
export default TalentVideo;
